import CreateGuideTopic from "./CreateGuideTopic"

export default CreateGuideTopic
